import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TooltipProps } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

interface InfoTooltipProps {
  tooltipText: string;
  placement: Placement;
  className: string;
  children?: React.ReactNode;
}

const ToolTip: React.FC<InfoTooltipProps> = ({
  tooltipText,
  placement,
  className,
  children,
}) => {
  const renderTooltip = (props: TooltipProps) => (
    <Tooltip id="button-tooltip" {...props}>
      <div style={{ whiteSpace: "pre-line" }}>{tooltipText}</div>
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      {children ? (
        <span className={className} style={{ display: "inline-flex" }}>
          {children}
        </span>
      ) : (
        <i className={`bi bi-info-circle ${className}`}></i>
      )}
    </OverlayTrigger>
  );
};

export default ToolTip;
